import { useState, type FormEvent } from "react";

interface SearchBarProps {
  defaultValue?: string;
  placeholder?: string;
  size?: "md" | "lg";
  onSearch: (keyword: string) => void;
}

export default function SearchBar({
  defaultValue = "",
  placeholder = "搜索法律法规、伦理文章与案例",
  size = "md",
  onSearch,
}: SearchBarProps) {
  const [value, setValue] = useState(defaultValue);

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    onSearch(value.trim());
  };

  const isLarge = size === "lg";

  return (
    <form
      onSubmit={handleSubmit}
      role="search"
      className={[
        "flex w-full items-center gap-2 rounded-full border border-background-300 bg-background-50 shadow-panel focus-within:border-primary-400",
        isLarge ? "px-4 py-2.5" : "px-3.5 py-2",
      ].join(" ")}
    >
      <span
        className={[
          "flex items-center justify-center text-foreground-400",
          isLarge ? "w-6 h-6" : "w-5 h-5",
        ].join(" ")}
      >
        <i className={isLarge ? "ri-search-2-line text-xl" : "ri-search-line text-lg"} />
      </span>
      <input
        type="search"
        value={value}
        onChange={(event) => setValue(event.target.value)}
        placeholder={placeholder}
        aria-label="搜索"
        className={[
          "w-full bg-transparent text-foreground-800 placeholder:text-foreground-400 focus:outline-none",
          isLarge ? "py-1 text-base" : "text-sm",
        ].join(" ")}
      />
      <button
        type="submit"
        className={[
          "shrink-0 items-center gap-1.5 whitespace-nowrap rounded-full bg-primary-600 font-medium text-background-50 transition-colors hover:bg-primary-700",
          isLarge ? "flex px-5 py-2 text-sm" : "hidden px-4 py-1.5 text-sm sm:flex",
        ].join(" ")}
      >
        <i className="ri-search-line" />
        搜索
      </button>
    </form>
  );
}